var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PropertiesPaginationCtrl = function () {
    function PropertiesPaginationCtrl($q) {
        _classCallCheck(this, PropertiesPaginationCtrl);

        this.q = $q;
        this.displayPagination = true;
        this.loaderDefer = this.q.defer();
    }

    _createClass(PropertiesPaginationCtrl, [{
        key: 'getPage',
        value: function getPage(offsetStart, offsetEnd) {
            var _this = this;

            return (this.allItems ? this.q.when() : this.loaderDefer.promise).then(function () {
                return {
                    items: _this.allItems.slice(offsetStart, offsetEnd + 1),
                    maxNumberOfResults: _this.allItems.length
                };
            });
        }
    }, {
        key: 'onNavigation',
        value: function onNavigation(riskUnits, pageNum, totalPages) {
            this.displayPagination = this.childPagination ? totalPages > 1 : true;
            this.onPaginationNavigation({ riskUnits: riskUnits, pageNum: pageNum });
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(_ref) {
            var allItems = _ref.allItems;

            if (allItems && allItems.currentValue && allItems.currentValue !== allItems.previousValue) {
                this.loaderDefer.resolve();
            }
        }
    }]);

    return PropertiesPaginationCtrl;
}();

PropertiesPaginationCtrl.$inject = ['$q'];
export default PropertiesPaginationCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/propertiespagination/PropertiesPaginationCtrl.js
// module id = 1144
// module chunks = 0